import React from 'react';
import RichTextEditor, { createValueFromString } from 'react-rte';

const TextAreaView = props => {
  const { value, openEdit, title = 'Notes', isEdit = true, subForm = false } = props;
  const hasNotes = value && value !== '';

  if (!isEdit && !hasNotes) return '';

  return (
    <div className={"cms" + (subForm && " cms__bar--margin-bot")}>
      <div className={"cms__bar" + (subForm ? " cms__bar--margin-bot" : " cms__section-head")}>
        <div className="cms__bar-left">
          <h3 className={subForm ? "h4" : "h3"}>{title}</h3>
        </div>
        <div className="cms__bar-right">
          {renderEditButton(hasNotes, openEdit, isEdit)}
        </div>
      </div>
      {renderEditor(hasNotes, value)}
      {renderAddButton(hasNotes, openEdit, isEdit, title)}
    </div>
  );
};

const renderEditor = (hasNotes, value) => {
  const notes = createValueFromString(value, 'html');
  if (hasNotes)
    return (
      <RichTextEditor
        value={notes}
        readOnly={true}
        className="cms__section-body text-area"
      />
    );
};

const renderEditButton = (hasNotes, openEdit, isEdit) => {
  if (hasNotes && isEdit)
    return (
      <span className="a--blue" onClick={openEdit}>
        Edit
      </span>
    );
};

const renderAddButton = (hasNotes, openEdit, isEdit, title) => {
  if (!hasNotes && isEdit)
    return (
      <div className="btn btn--white btn--full-width" onClick={openEdit}>
        + Add {title}
      </div>
    );
};

export default TextAreaView;



// WEBPACK FOOTER //
// ./src/components/shared/TextAreaView.js